"use client";

import { useEffect } from "react";

export default function SaveToLocalStorage({ keyName, value }) {
    useEffect(() => {
        if (value) {
            localStorage.setItem(keyName, JSON.stringify(value));
        }
    }, [keyName, value]);

    return null; // No UI needed
}
